import axios from "axios";
import { getToken } from "./tokenStore";
import { handleSessionOut } from "../HelperFunctions/HelperFunctions";
const userAuthApi = process.env.REACT_APP_AUTH_API_URL;


export const validateToken = async (token) => {
    try {
        // const token = await getToken();
        const res = await axios.post(`${userAuthApi}/v1/OpenApiauth/ValidateToken`, { token });

        if (res.status !== 200) {
            return handleSessionOut();
        }
        return true;

    } catch (err) {
        if (err.response && err.response.status === 401) {
            return false;
        }
        return false;
    }
};



/**
 * Centralized API caller
 *
 * @param {string} url - Base URL of the API
 * @param {"GET" | "POST" | "PUT" | "PATCH" | "DELETE"} [method="GET"] - HTTP method
 * @param {object|null} [data=null] - Request body (for GET/POST/PUT/PATCH requests)
 * @param {boolean} [includeToken=true] - Whether to include authorization token
 * @param {boolean} [skipValidation=false] - Skip validation checks
 * @returns {Promise<any>} - Resolves with response data
 */

export const centralizedApiCalling = async (
    url,
    method = "GET",
    data = null,
    includeToken = true,
    skipValidation = false
) => {
    let token = null;

    try {
        const type = url.split("/")[4];

        if (includeToken) {
            token = await getToken();


            if (skipValidation) {
                const isValid = await validateToken(token);
                if (!isValid) {
                    handleSessionOut()
                    return
                };
            }
        }

        const headers = {
            ...(token && { Authorization: `Bearer ${token}` }),
            ...(type !== "import_merchant_files" && { "Content-Type": "application/json" })
        };

        const response = await axios({
            url,
            method,
            headers,
            params: method === "GET" ? data : undefined,
            data: ["POST", "PUT"].includes(method) ? data : undefined
        });

        return {
            success: true,
            data: response.data,
            status: response.status
        };

    } catch (err) {
        if (err.response?.status === 401) {
            handleSessionOut();
        }
        return {
            success: false,
            status: err.response?.status || 500,
            error: err.response?.data || err.message
        };
    }
};



